// extracted by mini-css-extract-plugin
export var Block = "Block-module--Block--IseMo";
export var aniSpin = "Block-module--ani-spin--2yCn6";